import Vue from 'vue';
import Vuex from 'vuex';
import Cookie from 'js-cookie';

Vue.use(Vuex);

let state = {
  leftMenuStatus: Cookie.get('left_menu_status'),
  loginRememberPwd: Cookie.get('login_remember_pwd')==null?{}:JSON.parse(Cookie.get('login_remember_pwd')),
  loginUserInfo: Cookie.get('login_user_info')==null?null:JSON.parse(Cookie.get('login_user_info')),
  tokenInfo: Cookie.get('tokenInfo')==null?null: JSON.parse(Cookie.get('tokenInfo')),
  commonInfo:Cookie.get('commonInfo') == null?null:JSON.parse(Cookie.get('commonInfo'))
};
let actions = {};
let mutations = {
  doToggleLeftMenu: (state) => {
    let status = state.leftMenuStatus == 'open' ? 'close' : 'open';

    state.leftMenuStatus = status;
    Cookie.set('left_menu_status', status, {expires: 30*24*3600});
  },
  setTokenInfo: (state, val) => {
    if (val == null){
      state.tokenInfo = null;
      Cookie.remove('tokenInfo');
      return;
    }
    state.tokenInfo = val;
    if (typeof val === 'object'){
      val = JSON.stringify(val);
    }
    Cookie.set('tokenInfo', val);
  },
  clearTokenInfo: (state) => {
    state.tokenInfo = null;
    Cookie.remove('tokenInfo');
  },
  setLoginUserInfo: (state, val) => {
    state.loginUserInfo = val;

    if (typeof val === 'object'){
      val = JSON.stringify(val);
    }
    Cookie.set('login_user_info', val);
  },
  clearLoginUserInfo: (state) => {
    state.loginUserInfo = null;
    Cookie.remove('login_user_info');
  },
  setLoginRememberPwd: (state, val) => {
    state.loginRememberPwd = val;

    if (typeof val === 'object'){
      val = JSON.stringify(val);
    }
    Cookie.set('login_remember_pwd', val,{expires: 30*24*3600});
  },
  clearLoginRememberPwd: (state) => {
    state.loginRememberPwd = null;
    Cookie.remove('login_remember_pwd');
  },
  setCommonInfo: (state, val) => {
    if (val == null){
      state.commonInfo = null;
      Cookie.remove('commonInfo');
      return;
    }
    state.commonInfo = val;
    if (typeof val === 'object'){
      val = JSON.stringify(val);
    }
    Cookie.set('commonInfo', val);
  },
  clearCommonInfo: (state) => {
    state.commonInfo = null;
    Cookie.remove('commonInfo');
  },
};

const store = new Vuex.Store({state, actions, mutations});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js